import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import { makeStyles } from "@material-ui/core/styles";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import * as XLSX from "xlsx";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function VentaDirectaCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_MIXCALCO = process.env.REACT_APP_AREAS_MIXCALCO;
  const PASSWORD_CAMBIA_PRECIO = process.env.REACT_APP_PASSWORD_CAMBIA_PRECIO;
  const URL_SEND_MAIL = process.env.REACT_APP_URL_SEND_MAIL;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  // const [idsArticulos, setIdsArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("650a334ab99f0b3555a8cf16");
  const [selectedClienteName, setSelectedClienteName] = useState("VENTA MOSTRADOR");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedColaboradorName, setSelectedColaboradorName] = useState("");
  const [value, setValue] = useState("");
  const [codigo, setCodigo] = useState("");
  const [articuloNombre, setArticuloNombre] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inventarios, setInventarios] = useState([]);

  const [cliente, setCliente] = useState("");
  const [departamentoCliente, setDepartamentoCliente] = useState("");
  const [paqueteria, setPaqueteria] = useState("Por Definir");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(AREAS_GENERAL);
  const [selectedAreaName, setSelectedAreaName] = useState("General");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [salidaBodega, setSalidaBodega] = useState("NA");
  const [plazo, setPlazo] = useState(0);
  const [comision, setComision] = useState(0);
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [total_cajas, setTotalCajas] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);
  const [totalCaptura, setTotalCaptura] = useState(1);

  const [descuento, setDescuento] = useState(0);
  const [descuentoNumero, setDescuentoNumero] = useState(0);


  const [bancos, setBancos] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState();
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [pago, setPago] = useState();
  const [monto, setMonto] = useState(0);
  const [formaPago, setFormaPago] = useState();
  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transfer, setTransfer] = useState(0);
  const [destino, setDestino] = useState("NA");
  const [terminal, setTerminal] = useState("Tarjeta");
  const [saldo, setSaldo] = useState(0);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      piezasPorCaja: 0,
      cajas: 0,
      cantidad: 0,
      precio: 0,
      precioOriginal: 0,
      total: 0,
      articulosNombre: "",
      articulosCodigo: "",
      observacionesArticulo: "NA",
      idInv: "",
      costoUnitario:0,
      foto:"",
      fotoArticulo: "",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  useMemo(() => {
    // axios
    //   .get(`${URL_ARTICULOS}Activos`, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allArticulos = res.data;
    //     setArticulos(allArticulos);
    //     let result = allArticulos.map((a) => a._id);
    //     setIdsArticulos(result);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    axios
      .get(`${URL_CLIENTES}GeneralActivos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      })
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

      if(selectedArea){
    axios
      .get(`${URL_INVENTARIOS}DisponibleAlmacen/${selectedArea}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDisponible = response.data;
        setInventarios(allDisponible);

        setArticulos(allDisponible);
        // let result = allDisponible.map((a) => a.idArticulo);
        // setIdsArticulos(result);
      })
      .catch((err) => {
        console.log(err);
      });
    }
    axios
    .get(URL_BANCOS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allBancos = response.data;
      setBancos(allBancos);
    })
    .catch((err) => {
      console.log(err);
    });
  
  }, [selectedArea]);

const savePedido = async (event) => {
  event.preventDefault();

  if (!selectedCliente || !selectedArea) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Faltan datos, favor de revisar",
    });
    return;
  }

  setValidaBoton(false);
  toggleProgreso();

  try {
    const pedidoData = {
      fecha,
      clientes: selectedCliente,
      departamentosClientes: departamentoCliente,
      colaboradores: selectedColaborador,
      total_general: parseFloat(total_general).toFixed(2),
      observaciones,
      total_cantidad,
      paqueteria,
      comisionTDC,
      comisionFlete,
      subTotal: parseFloat(subTotal).toFixed(2),
      iva: parseFloat(iva).toFixed(2),
      impuestos: selectedImpuesto,
      surtido: "Si",
      autorizadoApartado: "No",
      autorizadoSurtido: "No",
      editado: "No",
      fechaModificado: fecha,
      creado: user.id,
      fecha_estimada: fecha,
      fecha_entrega: fecha,
      entregaInsumos: "No",
      piezasEntregadas: 0,
      piezasPendientes: total_cantidad,
      status: "Cerrado",
    };

    const pedidoResponse = await axios.post(URL_PEDIDOS, pedidoData, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    });

    const dataPedido = pedidoResponse.data;

    const surtidoData = {
      fecha,
      pedidos: dataPedido._id,
      observaciones,
      user: user.id,
      clientes: selectedCliente,
      areas: selectedArea,
      total_general: parseFloat(total_general).toFixed(2),
      saldo: parseFloat(saldo).toFixed(2),
      subTotal: parseFloat(subTotal).toFixed(2),
      iva: parseFloat(iva).toFixed(2),
      impuestos: selectedImpuesto,
      is_active: "Si",
      colaboradores: selectedColaborador,
      comisionPagada: "No",
      fotoEvidencia: "No",
      mail: "No",
      salidaBodega,
      plazo,
      comision,
      total_cantidad,
      noGuia: "Sin Guia",
      noFactura: "Sin Factura",
      empresas: selectedEmpresa,
    };

    const surtidoResponse = await axios.post(URL_SURTIDOS, surtidoData, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    });

    const dataSurtido = surtidoResponse.data;

    // Si hay pago inicial, creas Abono y actualizas saldo
    if (pago && monto > 0) {
      const saldoCalculado = parseFloat(total_general) - parseFloat(monto);

      const abonoData = {
        fecha,
        importe: parseFloat(monto).toFixed(2),
        clientes: selectedCliente,
        colaboradores: selectedColaborador,
        surtidos: dataSurtido._id,
        formaPago,
        concepto: "Abono",
        bancos: selectedBanco,
        comisionPagada: "No",
        observaciones: "NA",
        codigoAgrupado,
        editado: "No",
      };

      await axios.post(URL_ABONOS, abonoData, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });

      await axios.patch(
        `${URL_SURTIDOS}/${dataSurtido._id}`,
        { saldo: saldoCalculado.toFixed(2) },
        {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        }
      );
    }

    // Enviar mail si aplica
    if (dataSurtido.impuestos === 16) {
      enviaMail(dataSurtido.idSurtido, dataSurtido.updatedAt, dataPedido.idPedido);
    }

    // Guardar artículos de pedido y surtidos
    await Promise.all(
      inputFields.map(async (field) => {
        if (field.articulos && field.cantidad > 0) {
          const articuloPedidoData = {
            pedidos: dataPedido._id,
            articulos: field.articulos,
            cantidad: parseFloat(field.cantidad),
            cantidadProcesos: 0,
            pendiente_surtir: parseFloat(field.cantidad),
            surtido: 0,
            precio: parseFloat(field.precio).toFixed(2),
            total: parseFloat(field.total).toFixed(2),
            clientes: selectedCliente,
            fecha,
            autorizadoApartado: "No",
            autorizadoSurtido: "No",
          };

          const articuloPedidoResponse = await axios.post(
            URL_ARTICULOS_PEDIDO,
            articuloPedidoData,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          const articuloSurtidoData = {
            fecha,
            surtidos: dataSurtido._id,
            inventarios: field.idInv,
            cantidad: parseFloat(field.cantidad),
            articulos: field.articulos,
            pedidos: dataPedido._id,
            articulosPedido: articuloPedidoResponse.data._id,
            costoUnitario: field.costoUnitario,
            clientes: selectedCliente,
            areas: selectedArea,
          };

          await axios.post(URL_ARTICULOS_SURTIDOS, articuloSurtidoData, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          });
        }
      })
    );

    // Log
    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Pedido",
        detalle: `${dataPedido._id} ${total_general}`,
        user: user.id,
      },
      {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      }
    );

    // 🔹 AQUÍ GENERAMOS EL PDF TICKET CON LA MISMA FUNCIÓN QUE USAS EN OTRO COMPONENTE
    // Ajusta estos campos según tus estados actuales:
    const nombreCliente = selectedClienteName || ""; // <-- cambia al nombre real
    const numeroNota = dataSurtido.idSurtido || dataSurtido._id;       // folio/nota
    // const nombreArea = areaSeleccionada?.nombre || "";                 // <-- cambia al nombre real
    // const codigoClientes = clienteSeleccionado?.codigo || "";
    const nombreVendedor = user.nombre || "";
    // const telefonoCliente = clienteSeleccionado?.telefono || "";
    const descuento = 0; // si manejas descuento, cámbialo

    await PDFOCTicket(
      fecha,                    // fecha
      selectedCliente,          // idClientes
      nombreCliente,            // clientes (texto que se imprime)
      observaciones,            // observaciones
      numeroNota,               // numero (nota / folio)
      dataSurtido._id,          // idPDFOC -> se usa para GET /surtido/:id y para el QR
      user,                     // user (puedes mandar user.nombre si así lo usas)
      dataPedido._id,           // pedidos
      comisionTDC,              // comisionTDC
      comisionFlete,            // comisionFlete
      selectedImpuesto,         // impuestos
      subTotal,                 // subTotal
      iva,                      // iva
      total_general,            // total_general
      "", "", "", "", "", "",   // calle, numero_ext, numero_int, pais, estado, ciudad
      "", "", "", "", "",       // delegacion, colonia, cp, RFC, (2 extras por si acaso)
      paqueteria,               // paqueteria
      // nombreArea,               // area
      // codigoClientes,           // codigoClientes
      nombreVendedor,           // vendedor
      // telefonoCliente,          // telefono
      descuento                 // descuento
    );

    Swal.fire("Good job!", "Creado con éxito", "success");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: error.response?.data || "",
    });
    console.error(error);
    setValidaBoton(true);
  }
};

async function PDFOCTicket(
  fecha,
  idClientes,
  clientes,
  observaciones,
  numero,
  idPDFOC,
  user,
  pedidos,
  comisionTDC,
  comisionFlete,
  impuestos,
  subTotal,
  iva,
  total_general,
  calle,
  numero_ext,
  numero_int,
  pais,
  estado,
  ciudad,
  delegacion,
  colonia,
  cp,
  RFC,
  paqueteria,
  area,
  codigoClientes,
  vendedor,
  telefono,
  descuento
) {
  await axios
    .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allArticulosVenta = response.data;

      let arrayTabla = allArticulosVenta
        .map((a) => {
          return {
            id: a._id,
            articulos: a.articulos[0].codigo + " " + a.articulos[0].nombre,
            piezasPorCaja: a.articulos[0].piezasPorCaja,
            cantidad: a.cantidad,
            precio: a.articulosPedido[0].precio,
            total: a.articulosPedido[0].precio * a.cantidad,
            cajas: a.cantidad / a.articulos[0].piezasPorCaja,
          };
        })
        .filter(function (el) {
          return el != null;
        });

      let dataFinal = Object.values(arrayTabla);

      let totalKG = dataFinal.map((c) => parseFloat(c.cantidad));
      let TK = totalKG.reduce((t, total, index) => t + total, 0);

      let importes = dataFinal.map((c) => parseFloat(c.total));
      let TG = importes.reduce((t, total, index) => t + total, 0);

      let cajas = dataFinal.map((c) => parseFloat(c.cajas));
      let TC = cajas.reduce((t, total, index) => t + total, 0);

      let LA = dataFinal.length * 1.5;
      let largoTotal = LA + 10 + 13;

      let totalParcial = 0;

      let subTotalTabla = 0;
      let total_general_tabla = 0;
      let iva_tabla = 0;
      let impuesto_tabla = impuestos;

      const data = dataFinal
        .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
        .map((a) => {
          totalParcial = a.cantidad * a.precio;
          subTotalTabla = subTotalTabla + totalParcial;
          return [
            a.articulos,
            new Intl.NumberFormat("en-US").format(a.cajas),
            // a.piezasPorCaja,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.precio),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.total),
          ];
        });

      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });

      iva_tabla = (subTotalTabla * impuesto_tabla) / 100;
      total_general_tabla =
        subTotalTabla + comisionTDC + comisionFlete + iva_tabla;

      const doc = new jsPDF("p", "cm", [7.2, largoTotal]);

      // QR con el id del surtido
      // var base64 = qrcode.toDataURL(idPDFOC);
      // var img3 = new Image();
      // img3.src = base64;

      var img2 = new Image();
      img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";

      doc.addImage(img2, "png", 5, 1, 2, 2);

      doc.setFontSize(9).setFont(undefined, "bold");

      doc.text(`AMERICAN FLY`, 0.3, 1);
      doc.text(`CALLEJON 1ro Mixcalco No.9 B`, 0.3, 1.5);
      doc.text(`CENTRO (Area 3)`, 0.3, 2);
      doc.text(`CDMX, CP: 06020`, 0.3, 2.5);
      doc.text(`Tel: 55-5542-4483`, 0.3, 3);

      doc.text(`Fecha: ${fecha}`, 0.3, 3.5);
      doc.text(`Nota: ${numero}`, 0.3, 4);
      doc.text(
        `Piezas: ${new Intl.NumberFormat("en-US").format(
          TK
        )} / Cajas ${TC.toFixed(2)}`,
        0.3,
        4.5
      );
      doc.text(`Cliente: ${clientes}`, 0.3, 5);

      doc.autoTable({
        head: [
          [
            "Articulo",
            "Cajas",
            // "PPC",
            "Cant",
            "Precio",
            "Total",
          ],
        ],
        body: dataPDFLimpia,
        styles: {
          fontSize: 7,
          fontStyle: "bold",
          cellPadding: 0.1,
        },
        startY: 6.5,
        theme: "plain",
        margin: { left: 0.1, right: 0.1 },
        foot: [
          [
            "",
            "",
            {
              content: "Total Cajas",
              colSpan: 2,
              styles: { halign: "left" },
            },
            {
              content: new Intl.NumberFormat("en-US").format(TC),
              colSpan: 1,
            },
          ],
          [
            "",
            "",
            { content: "SubTotal", colSpan: 2, styles: { halign: "left" } },
            {
              content: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(subTotal),
              colSpan: 1,
            },
          ],
          [
            "",
            "",
            { content: `Comision`, colSpan: 2, styles: { halign: "left" } },
            {
              content: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(iva),
              colSpan: 1,
            },
          ],
          [
            "",
            "",
            {
              content: "Comision TDC",
              colSpan: 2,
              styles: { halign: "left" },
            },
            {
              content: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(comisionTDC),
              colSpan: 1,
            },
          ],
          [
            "",
            "",
            { content: "Flete", colSpan: 2, styles: { halign: "left" } },
            {
              content: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(comisionFlete),
              colSpan: 1,
            },
          ],
          [
            "",
            "",
            { content: "Total", colSpan: 2, styles: { halign: "left" } },
            {
              content: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(total_general),
              colSpan: 1,
            },
          ],
        ],
        showFoot: "lastPage",
      });

      var lines = doc.splitTextToSize(
        `Firma:______________________________`
      );
      doc.text(0.3, doc.autoTable.previous.finalY + 1.5, lines);

      var lines2 = doc.splitTextToSize(`*** Pendiente por Facturar ***`);
      doc.text(0.3, doc.autoTable.previous.finalY + 3, lines2);

      window.open(doc.output("bloburl"), "_blank");
      // doc.save(`Nota-${numero}.pdf`);
    })
    .catch((err) => {
      console.log(err);
    });
}


  function enviaMail(
    numero,
    fechaHora,
    pedido
  ) {
    let fechaHora2 = moment(fechaHora).format('YYYY-MM-DD');

    const dataIF = inputFields.map((a) => {
      if(a.cantidad > 0){
            return {
              foto: a.foto,
              fotoArticulo: a.fotoArticulo,
              cantidad: a.cantidad,
              articulos: a.articulos,
              articuloNombre: a.articulosNombre,
              articuloCodigo: a.articulosCodigo,
              cajas: a.cantidad / a.piezasPorCaja,
              idArticulo: a.idArtPed,
              precio: a.precio,
              piezasPorCaja: a.piezasPorCaja
            }
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(dataIF);

        let TC = dataFinal.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let totalParcial = 0;

        dataFinal.map(async (z) => {
          if(z.fotoArticulo == "Si"){
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${z.articulos}`;
         await axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              if(data.data.secure_url != null){
              z.foto = data.data.secure_url
            }else z.foto = process.env.PUBLIC_URL + "sinImagen.png"
            })
            .catch((err) => {
              console.log(err);
            });
          return z
        }else{
          z.foto = process.env.PUBLIC_URL + "sinImagen.png"
        }
        })
  
        setTimeout(() => {

        const data = dataFinal.map((a) => {
          totalParcial = a.cantidad * a.precio;
          return [
            a.foto,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            a.articuloCodigo,
            a.articuloNombre,
            new Intl.NumberFormat("en-US").format(a.cajas.toFixed(2)),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.precio),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(totalParcial),
          ];
        });

        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });

         const columnStyles = [
          { fontSize: .000001, textColor: [255, 255, 255], cellWidth: 20, },
        { fontSize: 9,textColor: ["#000000"] },
        { fontSize: 9,textColor: ["#000000"] },
        { fontSize: 9,textColor: ["#000000"] },
        { fontSize: 9,textColor: ["#000000"] },
        { fontSize: 9,textColor: ["#000000"] ,halign: 'right'},
        { fontSize: 9,textColor: ["#000000"] ,halign: 'right'},
        ];
        
      const doc = new jsPDF({compressPdf: true});
        var img = new Image();
        var img2 = new Image();
        const backgroundColor = ["#d1d2d4"];
        const backgroundColorBoxLightGray = ["#e6e7e9"];
        const backgroundColorBoxBlack = ["#231f20"];
        const backgroundColorBoxPurple = ["#07343d"];
        const margins = {  left: 5, right: 5 };

      img.src = process.env.PUBLIC_URL + "logoInstitucion.jpg";
      doc.addImage(img, "jpg", 15, 5, 33, 33);

      // img.src = process.env.PUBLIC_URL + "marcas.jpg";
      // doc.addImage(img, "jpg", 9, 28, 192, 10);
      // doc.setFontSize(10);
      
      doc.setFillColor(...backgroundColor);
      doc.rect(5, 40, 200, 6, 'F');
      doc.setTextColor("#000000");
      doc.text(`Tel: 55 1234 5678`,8, 44);

      doc.setTextColor("#000000");
      doc.text(`Cliente: ${cliente.codigo} - ${cliente.nombre_comercial}`,8, 52);
      doc.text(`Remisión: ${numero}`,80, 52);
      doc.text(`Pedido: ${pedido}`,160, 52);

      doc.setTextColor("#07343d");
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text(`tiendaAmFly.mx`,175, 44);
      doc.setTextColor("#000000");

      doc.setFontSize(14);
      doc.setFillColor(...backgroundColorBoxBlack);
      doc.rect(100, 4, 105, 22, 'F');
      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(74, 4, 25, 22, 'F');
      doc.setTextColor("#ffffff");
      doc.text(`NOTA DE SALIDA`,125, 12);
      doc.setFont('helvetica', 'normal');
      doc.text(`SALIDA BODEGA`,125, 17);
      doc.text(`México, D. F. a ${fechaHora2}`,125, 22);
        
        doc.autoTable({
          head: [[
              "",
              "CANTIDAD",
              "MODELO",
              "DESCRIPCION",
              "BULTO#",
              "PRECIO UNITARIO",
              "IMPORTE",
            ]],
          body: dataPDFLimpia,
          bodyStyles:{
            rowHeight : 22,
            valign: "middle"
          },
          didDrawCell: function(data) {
            if (data.column.index === 0 && data.cell.section === 'body') {
               var td = data.cell.raw;
               var img = td
               var dim = data.cell.height - data.cell.padding('vertical');
               var textPos = data.cell;
               doc.addImage(img, textPos.x,  textPos.y, 20, 20);
            }
          },
          styles: {
            fontSize: 10,
            overflow: "linebreak",
            columnWidth: "wrap",
            overflowColumns: "linebreak",
          },
          headStyles: {
            fillColor: ["#07343d"],
            lineWidth: 0,
            halign: 'center',
            valign: 'middle',
            fontSize: 8
          },
          footStyles: {
            fillColor: ["#07343d"],
          },
          columnStyles: columnStyles,
          theme:"grid",
          margin: { left: 5, right: 5 },
          startY: 55,
          showFoot: "lastPage",
        });

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(5, doc.autoTable.previous.finalY +1, 36, 6, 'F');
        doc.setTextColor("#ffffff");
        doc.setFontSize(8);
        doc.text(`TOTAL DE ARTICULOS`,7,  doc.autoTable.previous.finalY+5);
        doc.setTextColor("#000000");
        doc.text(`________________________________________________________________________________________________________________________________`,5,  doc.autoTable.previous.finalY+22);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setFont('helvetica', 'normal');
        doc.rect(40, doc.autoTable.previous.finalY +1, 40, 6, 'F');
        doc.text(new Intl.NumberFormat("en-US").format(total_cantidad) + " Piezas",42,  doc.autoTable.previous.finalY+5);

        doc.setFontSize(7.5);
        doc.text(`1. Esta es una venta en firme y no se acepta ningún tipo de descuento o devolución sin consentimiento previo.`,5,  doc.autoTable.previous.finalY+11);
        doc.text(`2. La mercancía viaja por cuenta y riesgo del cliente, no somos responsables por faltante.`,5,  doc.autoTable.previous.finalY+14);
        doc.text(`3. El pago de la mercancía debe realizarse en tiempo y forma pactados a la cuenta proporcionada por nosotros.`,5,  doc.autoTable.previous.finalY+17);

        var nota = "Debo(emos)  y pagare(mos)  incondicionalmente por  este  pagare a la orden  de TIENDA AM FLY en esta plaza,  el día estipulado en  este documento,  la cantidad estipulada  en este  documento,  valor recibido a  mi entera satisfacción, este pagare causará intereses a razón de 2% mensual a partir de la fecha de vencimiento, hasta su total liquidación, pagadero conjuntamente con el principal. Este pagare se rige en los términos de ley general de títulos y operaciones de crédito.";
        var lines = doc.splitTextToSize(nota, 129);
        doc.text(5,doc.autoTable.previous.finalY + 26, lines);

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY +1, 37, 6, 'F');
        doc.setTextColor("#ffffff");
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
        doc.text(`SUBTOTAL $`,153,  doc.autoTable.previous.finalY+5);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont('helvetica', 'normal');
        doc.rect(181, doc.autoTable.previous.finalY +1, 24, 6, 'F');
        doc.text(new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format((subTotal).toFixed(2)),183,  doc.autoTable.previous.finalY+5);

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY +8, 37, 6, 'F');
        doc.setTextColor("#ffffff");
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
        doc.text(`IMPUESTO $`,154,  doc.autoTable.previous.finalY+12);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont('helvetica', 'normal');
        doc.rect(181, doc.autoTable.previous.finalY +8, 24, 6, 'F');
        doc.text(new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format((iva).toFixed(2)),183,  doc.autoTable.previous.finalY+12);

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY +15, 37, 6, 'F');
        doc.setTextColor("#ffffff");
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
        doc.text(`TOTAL $`,159,  doc.autoTable.previous.finalY+19);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont('helvetica', 'normal');
        doc.rect(181, doc.autoTable.previous.finalY +15, 24, 6, 'F');
        doc.text(new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format((total_general).toFixed(2)),183,  doc.autoTable.previous.finalY+19);

        var lines = doc.splitTextToSize(`Observaciones: ${observaciones}`, 40);
        doc.text(145,doc.autoTable.previous.finalY + 26, lines);

        doc.setFont('helvetica', 'bold');
        doc.text(`Nombre Completo:__________________________________________________________________________  Firma:______________________________`,5,  doc.autoTable.previous.finalY+50);

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(6);
        doc.text(`ESTE DOCUMENTO NO REPRESENTA UN COMPROBANTE FISCAL`,67,  doc.autoTable.previous.finalY+60);
// doc.save(`Nota-${numero}.pdf`);

      var att = doc.output("arraybuffer");
      var base64File = encode(att);
      axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Solicitud de factura",
          email: process.env.REACT_APP_MAIL_ITAMERICANFLY,
          fileName: `Nota-${numero}.pdf`,
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Le solicitamos la realizar la factura con la informacion adjunta.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
    },1000)
  }

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        precioOriginal: 0,
        total: 0,
        articulosNombre: "",
        articulosCodigo: "",
        observacionesArticulo: "NA",
        idInv: "",
        costoUnitario:0,
        foto:"",
        fotoArticulo: "",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalCan = values.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let totalCajas = values.map((c) => parseFloat(c.cajas));
    let TCajas = totalCajas.reduce((t, total, index) => t + total, 0);
    setTotalCajas(TCajas);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(parseFloat(TG).toFixed(2));

    if (selectedImpuesto != 0) {
      setIva(parseFloat((selectedImpuesto * TG) / 100).toFixed(2));
    } else {
      setIva(0);
    }
    let temp1 = (TG * descuento) / 100;

    setDescuentoNumero(temp1);

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      parseFloat(temp1);

    setTotalGeneral(parseFloat(totTemp).toFixed(2));
  };

  const handleChangeInputObservaciones = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.observacionesArticulo = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = parseFloat(totalParcial).toFixed(2);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[name] = value;
        let totalParcial = i.cantidad * i.precio;
        i.total = parseFloat(totalParcial).toFixed(2);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if(i.disponible >= (event.target.value * i.piezasPorCaja) ){
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = parseFloat(totalParcial).toFixed(2);
      }else{
      i.cantidad = 0
        i.cajas = 0
        i.total = 0
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La cantidad excede el inventario!",
      });
    }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if(i.disponible >= event.target.value ){
        i.cantidad = event.target.value;
        i.cajas = (
          parseFloat(event.target.value) / parseFloat(i.piezasPorCaja)
        ).toFixed(2);
        let totalParcial = i.cantidad * i.precio;
        i.total = parseFloat(totalParcial).toFixed(2);
      }else{
      i.cantidad = 0
        i.cajas = 0
        i.total = 0
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La cantidad excede el inventario!",
      });
    }
  }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    if (
      inputFields.filter((e) => e.articulos == selectedArticulo.idArticulo).length > 0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El modelo ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.articulosNombre = "";
          i.articulos = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    } else {
      // articulos.map((a) => {
        // if (a._id == selectedArticulo._id) {
          let idArticulo = selectedArticulo.idArticulo;
          let piezasPorCaja = selectedArticulo.piezasPorCaja;
          let articulosNombre = selectedArticulo.nombre;
          let articulosCodigo = selectedArticulo.codigo;
          let idInv = selectedArticulo.idInv;
          let costoUnitario = selectedArticulo.costoUnitario
          let precio = selectedArticulo.venta;
          let precioOriginal = selectedArticulo.venta;
          let fotoArticulo = selectedArticulo.fotoArticulo
          let disponible = selectedArticulo.disponible
          handleChangeInputArticulo(
            id,
            idArticulo,
            piezasPorCaja,
            precio,
            precioOriginal,
            articulosNombre,
            articulosCodigo,
            idInv,
            costoUnitario,
            fotoArticulo,
            disponible
          );
        // }
      // });
    }
  }

  // function BuscaCodigo(id, event) {
  //   if (event.target.value.length >= 24) {
  //     if (
  //       inputFields.filter((e) => e.articulos == event.target.value).length > 0
  //     ) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "El modelo ya fue capturado!",
  //         showConfirmButton: false,
  //       });
  //       const newInputFields = inputFields.map((i) => {
  //         if (id === i.id) {
  //           i.articulosNombre = "";
  //           i.articulos = "";
  //         }
  //         return i;
  //       });
  //       setInputFields(newInputFields);
  //     } else {
  //       if (idsArticulos.includes(event.target.value)) {
  //         articulos.map((a) => {
  //           if (a._id == event.target.value) {
  //             let idArticulo = a.idArticulo;
  //             let piezasPorCaja = a.piezasPorCaja;
  //             let precio = a.venta;
  //             let precioOriginal = a.venta;
  //             let articulosNombre = a.codigo;
  //             handleChangeInputArticulo(
  //               id,
  //               idArticulo,
  //               piezasPorCaja,
  //               precio,
  //               precioOriginal,
  //               articulosNombre
  //             );
  //           }
  //         });
  //       } else {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: "El modelo no aparece en tu catalogo",
  //           showConfirmButton: false,
  //         });
  //         const newInputFields = inputFields.map((i) => {
  //           if (id === i.id) {
  //             i.articulosNombre = "";
  //             i.articulos = "";
  //           }
  //           return i;
  //         });
  //         setInputFields(newInputFields);
  //       }
  //     }
  //   } else {
  //     const newInputFields = inputFields.map((i) => {
  //       if (id === i.id) {
  //         i.articulos = event.target.value;
  //       }
  //       return i;
  //     });
  //     setInputFields(newInputFields);
  //   }
  // }

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    piezasPorCaja,
    precio,
    precioOriginal,
    articulosNombre,
    articulosCodigo,
    idInv,
    costoUnitario,
    fotoArticulo,
    disponible
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precio = precio;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.articulosNombre = articulosNombre;
        i.articulosCodigo = articulosCodigo;
        i.precioOriginal = precioOriginal;
        i.idInv = idInv;
        i.costoUnitario = costoUnitario
        i.fotoArticulo = fotoArticulo;
        i.disponible = disponible;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
    handleAddFields();
  };

  function ActualizaTotales() {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let totalCajas = inputFields.map((c) => parseFloat(c.cajas));
    let TCajas = totalCajas.reduce((t, total, index) => t + total, 0);
    setTotalCajas(TCajas);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(parseFloat(TG).toFixed(2));

    if (selectedImpuesto != 0) {
      setIva(parseFloat((selectedImpuesto * TG) / 100).toFixed(2));
    } else {
      setIva(0);
    }
    let temp1 = (TG * descuento) / 100;

    setDescuentoNumero(temp1);

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      parseFloat(temp1);

    setTotalGeneral(parseFloat(totTemp).toFixed(2));

    setSaldo(parseFloat(totTemp - efectivo - tdc - transfer).toFixed(2));
  }

  function calculaDescuento(e) {
    setDescuento(e);
    let temp1 = (subTotal * e) / 100;

    setDescuentoNumero(temp1);

    let temp = subTotal - temp1;
    
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (subTotal - temp1)) / 100);
    } else {
      setIva(0);
    }

    let totTemp = temp + parseFloat(comisionTDC) + parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer)
  }

    const options2 = clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  const options = articulos.map((option) => {
    const junta = option.codigo + option.nombre;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function jalaCliente(cliente) {
    setSelectedCliente(cliente._id);
    setSelectedClienteName(cliente.nombre_comercial);

    axios
      .get(`${URL_CLIENTES}/${cliente._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCliente = res.data;
        setCliente(allCliente);
        // setDescuento(allCliente.descuento);
        setSelectedColaborador(allCliente.vendedor[0]._id);
        setSelectedColaboradorName(allCliente.vendedor[0].nombre + " " + allCliente.vendedor[0].apellido);
        setDepartamentoCliente(allCliente.departamentosClientes[0]._id);
          })
          .catch((err) => {
            console.log(err);
          });

      }


  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    if (e != 0) {
      setIva((e * subTotal) / 100);
      
    } else {
      setIva(0);
    }
   

    setTotalGeneral(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );

    setSaldo(
      (e * subTotal) / 100 +
      subTotal +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) 
    - efectivo - tdc - transfer
    )

  }

  function jalaComisionTDC(e) {
    setComisionTDC(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }

    let temp = (selectedImpuesto * subTotal) / 100 +
    subTotal +
    parseFloat(e) +
    parseFloat(comisionFlete) -
    parseFloat((descuentoNumero * subTotal) / 100)
    
    setTotalGeneral(temp);

    setSaldo(temp - efectivo - tdc - transfer)
  }

  function jalaComisionFlete(e) {
    setComisionFlete(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }

        let temp = (selectedImpuesto * subTotal) / 100 +
    subTotal +
    parseFloat(e) +
    parseFloat(comisionTDC) -
    parseFloat((descuentoNumero * subTotal) / 100)

    setTotalGeneral(temp);

    setSaldo(temp - efectivo - tdc - transfer)
  }

  function autorizaCambio() {
    if (password == randomCambiaPrecio) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
      Swal.fire("Good job!", "Se autorizo con exito", "success");
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function solicitarAut() {
    setMailAutEnviado(true);

    axios
      .post(
        URL_SEND_MAIL,
        {
          subject: "Cambio de Precio",
          email: "dany@lynqro.com",
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
       <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>La tienda ${user.nombre} ${user.apellido} esta solicitando un cambio de precio, si lo autorizas proporciona la clave ${randomCambiaPrecio}</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
       <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
       </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaArea(e){
    setArticulos([])
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        precioOriginal: 0,
        total: 0,
        articulosNombre: "",
        articulosCodigo: "",
        observacionesArticulo: "NA",
        idInv: "",
        costoUnitario:0,
        foto:"",
        fotoArticulo: "",
      },
    ])
    setSelectedArea(e);
    areas.map((a)=>{
      if(a._id == e){
        setSelectedAreaName(a.name)
      }
    })
  }

  // function importarArchivo(event) {
  //   const target = event.target;
  //   const value = target.type === "checkbox" ? target.checked : target.value;
  //   const name = target.name;
  //   let hojas = [];

  //   if (name === "file") {
  //     let reader = new FileReader();
  //     reader.readAsArrayBuffer(target.files[0]);
  //     reader.onloadend = (e) => {
  //       var data = new Uint8Array(e.target.result);
  //       var workbook = XLSX.read(data, { type: "array" });

  //       workbook.SheetNames.forEach(function (sheetName) {
  //         // Here is your object
  //         var XL_row_object = XLSX.utils.sheet_to_json(
  //           workbook.Sheets[sheetName]
  //         );
  //         hojas.push({
  //           data: XL_row_object,
  //           sheetName,
  //         });
  //       });

  //       let A1 = hojas[0].data;

  //       // Crear un objeto que mapee los idArticulo de los artículos a sus objetos correspondientes

  //       // Si queremos comprar con nombre
  //       const articulosMap = {};
  //       inventarios.forEach((articulo) => {
  //         articulosMap[articulo.nombre] = articulo;
  //       });
  //       const articulosNoEncontrados = [];
  //       for (const a of A1) {
  //         const articulo = articulosMap[a.nombre];


  //         // Si queremos comprar con id Articulo
  //       // const articulosMap = {};
  //       // inventarios.forEach((articulo) => {
  //       //   articulosMap[articulo.idArticulo] = articulo;
  //       // });

  //       // const articulosNoEncontrados = [];

  //       // // Iterar sobre A1 una sola vez
  //       // for (const a of A1) {
  //       //   const articulo = articulosMap[a.idArticulo];


  //         if (articulo) {
  //           inputFields.push({
  //             id: uuidv4(),
  //             articulos:  articulo.idArticulo,
  //             piezasPorCaja: articulo.piezasPorCaja,
  //             cajas: a.cantidad / articulo.piezasPorCaja,
  //             cantidad: a.cantidad,
  //             precio: a.precio,
  //             precioOriginal: articulo.venta,
  //             total: a.precio * a.cantidad,
  //             articulosNombre: articulo.nombre,
  //             articulosCodigo: articulo.codigo,
  //             observacionesArticulo: "NA",
  //             idInv: articulo.idInv,
  //             costoUnitario: articulo.costoUnitario,
  //             foto:"",
  //             fotoArticulo: "",
  //           });
  //         } else {
  //           // // Si no se encuentra el artículo, agregarlo a la lista de no encontrados por idArticulo
  //           //   articulosNoEncontrados.push(a.idArticulo);


  //           // Si no se encuentra el artículo, agregarlo a la lista de no encontrados por nombre
  //           articulosNoEncontrados.push(a.nombre);
  //         }
  //       }

  //       // Verificar si se encontraron artículos que no estaban en el mapa
  //       if (articulosNoEncontrados.length > 0) {
  //         const mensaje = `Los siguientes articulos no se encontraron: ${articulosNoEncontrados.join(
  //           ", "
  //         )}`;
  //         Swal.fire({
  //           title: "Artículos no encontrados",
  //           text: mensaje,
  //           icon: "warning",
  //           button: "Entendido",
  //         });
  //       }

  //       ActualizaTotales();
  //     };
  //   }
  // }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 align="center">Venta Directa</h3>
          {/* <Form > */}
          <Row>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                disabled
              />
            </Col>
            <Col>
              <Label>Empresa</Label>
                <Input
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Empresa</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
              <Label className="mr-sm-2">Cliente</Label>
              {/* <Input
                className="col-sm-12"
                type="select"
                value={selectedCliente}
                required
                onChange={(e) => {
                  jalaCliente(e.target.value);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .filter(cliente => user.vendedor === "Si" ? cliente.vendedor[0].email === user.email : true)
                  .sort((a, b) => a.nombre_comercial.localeCompare(b.nombre_comercial))
                  .map((a) => (
                    <option key={a._id} value={a._id}>
                      {a.nombre_comercial} {a.codigo}
                    </option>
                  ))}
              </Input> */}
              <Autocomplete
                                  size="small"
                                  value={value}
                                  onChange={(event, selectedCliente) => {
                                    if (selectedCliente) {
                                      jalaCliente(selectedCliente);
                                      setValue(selectedCliente);
                                    }
                                  }}
                                  options={options2.sort(
                                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                                  )}
                                  groupBy={(option) => option.firstLetter}
                                  getOptionLabel={(option) => option.junta}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Selecciona"
                                      variant="outlined"
                                    />
                                  )}
                                  renderOption={(option) => (
                                    <React.Fragment>
                                      {option.codigo} {option.nombre_comercial}
                                    </React.Fragment>
                                  )}
                                />
            </Col>
            <Col md={2}>
              <Label>Vendedor</Label>
              <Input
                type="select"
                value={selectedColaborador}
                onChange={(e) => {
                  const selectedIndex = e.target.selectedIndex;
                  const selectedOption = e.target.options[selectedIndex];
                  const selectedOptionText = selectedOption.text;
                  setSelectedColaboradorName(selectedOptionText);
                  setSelectedColaborador(e.target.value);
                }}
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>


            <Col md={1}>
              <Label>Paqueteria</Label>
              <Input
                type="text"
                placeholder="Paqueteria"
                value={paqueteria}
                required
                onChange={(e) => {
                  setPaqueteria(e.target.value);
                }}
              />
            </Col>
                  <Col md={1}>
                    <Label for="exampleEmail" className="mr-sm-2">
                     Salida Bodega
                    </Label>
                    <Input
                      type="text"
                      placeholder="Salida Bodega"
                      value={salidaBodega}
                      required
                      onChange={(e) => {
                        setSalidaBodega(e.target.value);
                      }}
                    />
                  </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Surtir de Almacen</Label>
              <Input
                type="select"
                value={selectedArea}
                onChange={(e) => {
                  jalaArea(e.target.value);
                }}
              >
                <option value="">Selecciona un almacen</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a._id != AREAS_MIXCALCO) {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={1}>
              <Label>Comision TDC</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={comisionTDC}
                className={`form-control`}
                onValueChange={(value) => {
                  jalaComisionTDC(value);
                }}
              />
            </Col>
            <Col md={1}>
              <Label>Comision</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                defaultValue={0}
                decimalsLimit={2}
                value={comision}
                className={`form-control`}
                onValueChange={(value) => {
                  setComision(value);
                }}
              />
            </Col>
            <Col md={1}>
              <Label>Flete</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={comisionFlete}
                className={`form-control`}
                onValueChange={(value) => {
                  jalaComisionFlete(value);
                }}
              />
            </Col>

            {/* <Col md={1}>
              <Label>Descuento %</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={descuento}
                onChange={(e) => {
                  calculaDescuento(e.target.value);
                }}
              />
            </Col> */}

            <Col md={1}>
              <Label>Impuestos %</Label>
                <Input
                    type="select"
                    value={selectedImpuesto}
                    required
                    onChange={(e) => {
                      calculaImpuesto(e.target.value);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="16">Si</option>
                    <option value="0">No</option>
                </Input>
            </Col>

            <Col md={1}>
              <Label>Plazo</Label>
              <Input
                type="select"
                placeholder="Plazo"
                value={plazo}
                required
                onChange={(e) => {
                  setPlazo(e.target.value);
                }}
              >
                <option value="">Plazo</option>
                <option value="0">0</option>
                <option value="30">30</option>
                <option value="60">60</option>
                <option value="90">90</option>
                <option value="120">120</option>
                <option value="150">150</option>
                <option value="180">180</option>
              </Input>
            </Col>

            <Col md={1}>
              <Label>Sub Total</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={subTotal}
                disabled
                className={`form-control`}
              />
            </Col>
            <Col md={1}>
              <Label>IVA</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={iva}
                disabled
                className={`form-control`}
              />
            </Col>
            {/* <Col md={1}>
              <Label>Descuento $</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={descuentoNumero}
                disabled
              />
            </Col> */}
            <Col md={1}>
              <Label>Total</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={total_general}
                disabled
                className={`form-control`}
              />
            </Col>

            <Col md={1}>
              <Label>Piezas</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Piezas"
                value={total_cantidad}
                required
                disabled
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            <Col md={1}>
              <Label>Cambio de Precio</Label>
              <Button
                size="sm"
                className="btn"
                color="info"
                onClick={(e) => toggleCambiaPrecio()}
              >
                Solicitar
              </Button>
            </Col>
          </Row>
          <br />
          {/* <Row>
            <Col>
              <Input
                required
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivo(event)}
              />
            </Col>
          </Row> */}

          {/* Tabla Articulos */}

          {/* <Form className={classes.root}> */}
          <Table borderless>
            <thead>
              <tr>
                {/* <th style={{ maxWidth: "120px" }}>Codigo Qr</th> */}
                <th>Buscador</th>
                <th>Articulo</th>
                <th style={{ maxWidth: "60px" }}>Disponible</th>
                {/* <th>Observaciones</th> */}
                <th style={{ maxWidth: "60px" }}>Cajas</th>
                <th style={{ maxWidth: "60px" }}>Pzs x Caja</th>
                <th style={{ maxWidth: "60px" }}>Cantidad</th>
                <th style={{ maxWidth: "60px" }}>Precio Original</th>
                <th style={{ maxWidth: "60px" }}>Precio</th>
                <th style={{ maxWidth: "80px" }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {inputFields.map((inputField) => (
                <>
                <tr>
                  {/* <td style={{ maxWidth: "120px" }}>
                    <Input
                      name="articulos"
                      type="string"
                      value={inputField.articulos}
                      onChange={(event) => {
                        BuscaCodigo(inputField.id, event);
                      }}
                    ></Input>
                  </td> */}
                  <td>
                    <Autocomplete
                      size="small"
                      value={inputField.articulosNombre}
                      onChange={(event, selectedArticulo) => {
                        setCodigo(selectedArticulo.codigo);
                        setArticuloNombre(selectedArticulo.nombre);
                        BuscaArticulo(inputField.id, selectedArticulo);
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.codigo} {option.nombre}
                        </React.Fragment>
                      )}
                    />
                  </td>
                  <td>
                    <Input
                      name="articulo"
                      type="string"
                      placeholder="Articulo"
                      value={inputField.articulosCodigo + " " + inputField.articulosNombre}
                      disabled
                    />
                  </td>
                  <td style={{ maxWidth: "60px" }}>
                    {/* <Input type="select" disabled>
                      {inventarios.map((a) => {
                        if (inputField.articulos == a.idArticulo) {
                          return <option>{a.disponible}</option>;
                        }
                      })}
                    </Input> */}
                    <Input
                      name="Disponible"
                      type="string"
                      placeholder="Disponible"
                      value={inputField.disponible}
                      disabled
                    />
                  </td>
                  {/* <td>
                <Input
                    name="observaciones"
                    type="text"
                    placeholder="observaciones"
                    value={inputField.observacionesArticulo}
                    required
                    onChange={(event) =>
                      handleChangeInputObservaciones(inputField.id, event)
                    }
                  />
                </td> */}
                   <td style={{ maxWidth: "60px" }}>
                    {inputField.idInv != "" ? (
                      <Input
                      name="cajas"
                      type="string"
                      value={inputField.cajas}
                      onChange={(event) =>
                        handleChangeInputCajas(inputField.id, event)
                      }
                    ></Input>
                    ):(
                      <Input
                      name="cajas"
                      type="string"
                      value={inputField.cajas}
                      disabled
                    ></Input>
                    )}
                  </td>
                  <td style={{ maxWidth: "60px" }}>
                    <Input
                      name="piezasPorCaja"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.piezasPorCaja}
                      required
                      disabled
                    />
                  </td>
                  <td style={{ maxWidth: "60px" }}>
                    {inputField.idInv != "" ? (
                      <Input
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    />
                    ):(
                      <Input
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      disabled
                    />
                    )}
                    
                  </td>
                  <td style={{ maxWidth: "60px" }}>
                    <Input
                      // bsSize="sm"
                      name="precioOriginal"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="PrecioOriginal"
                      value={inputField.precioOriginal}
                      disabled
                    />
                  </td>
                  <td style={{ maxWidth: "60px" }}>
                    <Input
                      style={
                        inputField.precioOriginal - 50 > inputField.precio
                          ? { backgroundColor: "#ed8c8c" }
                          : null
                      }
                      // bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={inputField.precio}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </td>
                  <td style={{ maxWidth: "80px" }}>
                    <Input
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="total"
                      value={inputField.total}
                      disabled
                    />
                  </td>
                  <td>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </td>
                </tr>
                
                </>
              ))}
            </tbody>
            {/* <tr>
              <td></td>
              <td></td>
              <td style={{ maxWidth: "60px" }}></td>
                  <td style={{ maxWidth: "60px" }}>
                    <Label>Total Cajas</Label>
                  <Input
                type="number"
                min="0"
                step="any"
                placeholder="Cajas"
                value={total_cajas}
                disabled
              />
                  </td>
                </tr> */}
          </Table>
          <br />
          <Row>
            <Col md={5}></Col>
            <Col md={1}>
            <Label>Total Cajas</Label>
                  <Input
                type="number"
                min="0"
                step="any"
                placeholder="Cajas"
                value={total_cajas}
                disabled
              /></Col>
          </Row>
          <Row>
            {/* </Row> */}
            <br />


          </Row>
          {/* </Form> */}
          {/* Termina Tabla Articulos */}

          <Row>
            {/* </Row> */}
            <br />
            <Col md={3}>
            <Input
              type="checkbox"
                 onChange={(event) => setPago(event.currentTarget.checked)}
                 checked={pago}
            />

            <h4 className="subMenuTitulo">Deseas Pagar la Nota?</h4>
            </Col>
           
            {pago ? (
              <>
                {/* <Row> */}
                <Col md={2}>
                                  <Label className="mr-sm-2">Forma de Pago</Label>
                                  <Input
                                    type="select"
                                    value={formaPago}
                                    onChange={(e) => {
                                      setFormaPago(e.target.value);
                                    }}
                                  >
                                    <option value="">Selecciona una Forma de Pago</option>
                                    <option value="Efectivo">Efectivo</option>
                                    <option value="Transfer">Transfer</option>
                                    <option value="TDC">TDC</option>
                                    <option value="Bonificacion">Bonificacion</option>
                                  </Input>
                                </Col>
                                
                                <Col md={2}>
                                                  <Label className="mr-sm-2">Banco</Label>
                                                  <Input
                                                    type="select"
                                                    value={selectedBanco}
                                                    onChange={(e) => {
                                                      setSelectedBanco(e.target.value);
                                                    }}
                                                  >
                                                    <option value="">Selecciona un Banco</option>
                                                    {bancos
                                                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                                                      .map((a) => {
                                                        return (
                                                          <option value={a._id}>
                                                            {a.banco} {a.cuenta}
                                                          </option>
                                                        );
                                                      })}
                                                  </Input>
                                                </Col>

                  <Col md={2}>
                    <Label>Monto</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={monto}
                      required
                      onChange={(e) => {
                        setMonto(e.target.value);
                      }}
                    />
                  </Col>
                {/* </Row> */}
              </>
            ) : undefined}
          </Row>
          <br />
          <Row>
            <Col md={1}>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabindex="-1"
                  onClick={savePedido}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
              )}
            </Col>
            <Col md={1}>
              <Button
                href="/ListadoPedidos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          {/* </Form> */}
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Precio</h4>
            </ModalHeader>
            <ModalBody>
              {mailAutEnviado == false ? (
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => solicitarAut()}
                  >
                    Solicitar Autorizacion
                  </Button>
                </Col>
              ) : (
                <>
                  <Input
                    bsSize="sm"
                    type="password"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <br />
                  <Row>
                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => autorizaCambio()}
                      >
                        Autorizar
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => solicitarAut()}
                      >
                        Reenviar Solicitud
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default VentaDirectaCreate;
